import styled from "styled-components";

export const ViewPainelPermissoes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  margin-top: 15px;

  .area {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .area-header {
    display: flex;
    align-items: center;
    gap: 1.5rem;
  }

  .area-label {
    font-size: 14px;
    color: ${(props) => props.theme.colors.tertiary};
    cursor: pointer;
  }

  .area-indent {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding-left: calc(30px + 2.5rem);
    text-align: start;
  }

  .area-info {
    position: relative;
    display: inline-flex;
    align-items: center;
  }

  .area-info-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    border: 1px solid ${(props) => props.theme.colors.tertiary};
    color: ${(props) => props.theme.colors.tertiary};
    font-size: 10px;
    font-style: italic;
    font-family: Georgia, "Times New Roman", serif;
    line-height: 1;
    cursor: help;
    user-select: none;
  }

  .area-info .tooltip {
    position: absolute;
    bottom: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
    width: max-content;
    max-width: 230px;
    background: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.white};
    padding: 0.7rem 1rem;
    border-radius: 6px;
    font-size: 11px;
    font-style: normal;
    line-height: 1.4;
    text-align: center;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.15s ease;
    z-index: 10;
    pointer-events: none;
  }

  .area-info:hover .tooltip {
    opacity: 1;
    visibility: visible;
  }

  .pills {
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
  }

  .acao-wrap {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
  }

  .subpills {
    display: flex;
    gap: 0.5rem;
  }

  .pill {
    font-size: 12px;
    padding: 0.5rem 1.5rem;
    border-radius: 999px;
    border: 1px solid ${(props) => props.theme.colors.elements};
    background: transparent;
    color: ${(props) => props.theme.colors.tertiary};
    cursor: pointer;
    transition: 0.2s;
    white-space: nowrap;

    &.active {
      background: ${(props) => props.theme.colors.primary};
      border-color: ${(props) => props.theme.colors.primary};
      color: ${(props) => props.theme.colors.white};
    }

    &.locked {
      cursor: default;
      opacity: 0.75;
    }
  }

  .pill.sub {
    font-size: 11px;
    padding: 0.35rem 1.1rem;
  }
`;
